import { Hexagon } from "lucide-react";

const PHRASES = [
  "A little sweet",
  "A little wild",
  "Raw beeswax",
  "Hand-poured small batch",
  "Family apiary",
  "First honey harvest · Spring 2027",
];

function Row({ hidden = false }) {
  return (
    <div className="flex items-center shrink-0" aria-hidden={hidden}>
      {PHRASES.map((p) => (
        <span key={p} className="flex items-center">
          <span className="font-serif-display italic text-lg sm:text-xl text-[#5A4D44] px-6">{p}</span>
          <Hexagon className="w-3.5 h-3.5 text-[#D97706] shrink-0" fill="#D97706" fillOpacity="0.25" />
        </span>
      ))}
    </div>
  );
}

export function Marquee() {
  return (
    <div className="bg-[#FAF5EE] border-y border-[#E6D7C3] py-5 overflow-hidden" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
